/*
 *  ___                  __                __  _ _
 *   | |_  _     _ |_ |_|_    _  _ _ _ _  /  \(_(_|. _  _
 *   | | )(_)|_|(_)| )|_|__)(|_)| (-_)_)  \__/| | ||| )(-
 *              _/           |
 */

export const form = {
  'selected-premium': {
    'monthly-contribution': null,
    'cash-bonus-premium': null,
    'update-option': null,
    'lumpsum-contribution': null,
  },
  'cover-level': {
    'low-cover': null,
    'medium-cover': null,
    'high-cover': null,
  },
  'life-assured-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
    title: null,
    'marital-status': null,
    nationality: null,
    gender: null,
  },
  'life-assured-contact-details': {
    'cell-phone': null,
    'whatsapp-phone': null,
    email: null,
  },
  'life-assured-postal-address': {
    addressee: null,
    'po-box-or-private-bag': null,
    'area-code': null,
    street: null,
    suburb: null,
    town: null,
    region: null,
  },
  'life-assured-employment-details': {
    occupation: null,
  },
  'spouse-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
    'marital-status': null,
    title: null,
    gender: null,
  },
  'spouse-contact-details': {
    'cell-phone': null,
    'work-phone': null,
  },
  'spouse-is-trustee': null,
  'trustee-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
    'marital-status': null,
    title: null,
    gender: null,
  },
  'trustee-contact-details': {
    'cell-phone': null,
    'work-phone': null,
  },
  'beneficiary-details': [],
  'life-assured-health-details': {
    'presently-in-good-health': null,
    'risky-occupation-hobbies': null,
    'taking-prescriptions': null,
    'sexually-transmitted-diseases': null,
    'refused-application-or-increased-premium': null,
    'hereditary-diseases': null,
    'height-in-cm': null,
    'weight-in-kg': null,
    'weight-change': null,
    'beers-per-week': null,
    'wine-per-week': null,
    'total-weekly-spirits': null,
    'alcohol-past-consumption': null,
    smoker: null,
    'smoking-per-day': null,
    'smoking-preference': null,
  },
  'health-concerns': [],
  'payment-method-selection': {
    'debit-order': null,
    'stop-order': null,
  },
  'payment-start-date': null,
  'payer-person-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
  },
  'payer-person': {
    myself: null,
    'my-spouse': null,
  },
  'life-assured-is-payer': null,
  'payment-bank-details': {
    'account-holder-name': null,
    'account-type': null,
    'account-entity-name': null,
    'account-branch-name': null,
    'account-number': null,
  },
  'payment-employment-details': {
    'employer-organisation': null,
    'employee-number': null,
  },
  'payer-signature': null,
  documents: {
    'id-document': [],
    'passport-document': [],
  },
  'acceptance-signature': null,
  'application-acceptance-date': null,
  'application-accepted': null,
}
